var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "componentTextResume" }, [
    _c("div", { staticClass: "title" }, [
      _c("i", { staticClass: "fa-solid fa-hand-point-up" }),
      _c("h4", [
        _vm._v("\n            " + _vm._s(_vm.title) + " "),
        _c("br"),
        _c("b", [
          _vm._v(_vm._s(_vm.numberSpacing(_vm.value)) + " " + _vm._s(_vm.label))
        ])
      ])
    ]),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(
          _vm
            .$t("dash.reporting.pdf.textResume.text")
            .replace(
              "%s",
              "<b>" +
                (_vm.pourcentage >= 0 ? "augmentation" : "diminution") +
                "</b>"
            )
            .replace(
              "%p",
              "<span class='value'>" + _vm.pourcentage + "%</span><br>"
            ) +
            " <b>" +
            _vm.DateStart.toLocaleString("fr-FR", {
              year: "numeric",
              month: "long",
              day: "numeric"
            }) +
            " - \n        " +
            _vm.DateEnd.toLocaleString("fr-FR", {
              year: "numeric",
              month: "long",
              day: "numeric"
            }) +
            "</b>"
        )
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }